import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from './Logo';
import { useLang } from '../LangContext';
import { company } from '../i18n';

/**
 * Footer — global footer for all pages. Uses real Router links.
 */
export default function Footer() {
  const { lang, t } = useLang();
  const labels = lang === 'de'
    ? {
        collectie: 'Kollektion', impressum: 'Impressum', juridisch: 'Rechtliches',
        ramen: 'Fenster', deuren: 'Türen', lichtschachten: 'Lichtschächte',
        werkwijze: 'Vorgehen', faq: 'FAQ', contact: 'Kontakt',
        stalen: 'Gratis Muster', configurator: 'Konfigurator', offerte: 'Angebot',
        privacy: 'Datenschutz', terms: 'AGB',
      }
    : {
        collectie: 'Collectie', impressum: 'Impressum', juridisch: 'Juridisch',
        ramen: 'Ramen', deuren: 'Deuren', lichtschachten: 'Lichtschachten',
        werkwijze: 'Werkwijze', faq: 'FAQ', contact: 'Contact',
        stalen: 'Gratis stalen', configurator: 'Configurator', offerte: 'Offerte',
        privacy: 'Privacy', terms: 'Voorwaarden',
      };

  const TermsLink = () => (
    <Link to={lang === 'de' ? '/agb' : '/voorwaarden'} data-testid="footer-link-terms" className="hover:text-white">
      {labels.terms}
    </Link>
  );

  return (
    <footer data-testid="footer" className="relative bg-[#111] text-[#9A9893] pt-24 pb-12">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="inline-block">
            <Wordmark size={24} testId="wordmark-footer" />
          </Link>
          <p className="mt-5 text-white/55 text-[14px] max-w-md">{t.footer.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white/40 text-[11px] uppercase tracking-[0.22em] mb-5">{labels.collectie}</h4>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/ramen" className="hover:text-white">{labels.ramen}</Link></li>
            <li><Link to="/deuren" className="hover:text-white">{labels.deuren}</Link></li>
            <li><Link to="/lichtschachten" className="hover:text-white">{labels.lichtschachten}</Link></li>
            <li><Link to="/configurator" className="hover:text-white">{labels.configurator}</Link></li>
            <li><Link to="/gratis-stalen" className="hover:text-white">{labels.stalen}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white/40 text-[11px] uppercase tracking-[0.22em] mb-5">{labels.impressum}</h4>
          <ul className="space-y-2 text-[14px] leading-relaxed">
            <li>{company.name}</li>
            <li>{company.street}</li>
            <li>{company.postal} {company.city}, {lang === 'de' ? 'Niederlande' : 'Nederland'}</li>
            <li className="pt-3">{lang === 'de' ? 'Direktor' : 'Directeur'}: Gerhard Roß</li>
            <li>KvK 42004418</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white/40 text-[11px] uppercase tracking-[0.22em] mb-5">{labels.juridisch}</h4>
          <ul className="space-y-3 text-[14px]">
            <li><a href={`mailto:${company.email}`} className="hover:text-white">{company.email}</a></li>
            <li><a href={`tel:${company.phoneNL.replace(/\s/g, '')}`} className="hover:text-white">{company.phoneNL}</a></li>
            <li><Link to="/contact" className="hover:text-white">{labels.contact}</Link></li>
            <li><Link to={lang === 'de' ? '/impressum' : '/colofon'} className="hover:text-white">{lang === 'de' ? 'Impressum' : 'Colofon'}</Link></li>
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-white">{labels.privacy}</Link></li>
            <li><TermsLink /></li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 mt-16 pt-8 border-t border-white/8 text-[12px] text-white/40 flex flex-col sm:flex-row gap-3 justify-between">
        <span>© {new Date().getFullYear()} {company.name} — Horrenmaker.nl</span>
        <span>{lang === 'de' ? 'Hergestellt in Arnhem.' : 'Gemaakt in Arnhem.'}</span>
      </div>
    </footer>
  );
}
